/** @jsxImportSource @emotion/react */
import React from "react";
import "../SwapAndSend";
import { css } from "@emotion/react";

export interface SwapAndSendWarningProps {
  visible?: boolean;
}

export const SwapAndSendWarning: React.FC<SwapAndSendWarningProps> = ({ visible }) => {
  if (!visible) {
    return null;
  }

  const styledWarning = css`
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    /* identical to box height, or 16px */

    display: flex;
    align-items: center;
    text-align: center;

    color: #9eafb1;
  `;

  return (
    <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
      <p css={styledWarning} className="m-0">
        Please ensure the address you enter is accurate.
        <a
          css={styledWarning}
          className="ms-1 text-decoration-underline"
          href={
            "https://help.bebop.xyz/en/articles/7866102-why-am-i-receiving-an-error-on-the-you-send-address"
          }
          target="_blank"
          rel="noreferrer"
        >
          Learn more.
        </a>
      </p>
    </div>
  );
};
